export const environment = {
  production: false,
  title: 'RITALIN',
  baseUrl: 'https://ritalinperu.com',
  seoDescription: 'RITALIN Perú: Tu farmacia digital de confianza. Compra RITALIN (metilfenidato) y tratamientos para el TDAH con envío rápido y seguro.',
  seoKeywords: 'ritalin, Ritalin Peru, metilfenidato, TDAH, déficit de atención, comprar Ritalin, salud neurológica',
  catalogFilter: ['ritalin'],
  contactPhone: 'https://wa.me/51949823288',
  favicon: 'favicon-ritalin.svg',
  heroTitle: 'Tu Tratamiento,<br/><span class="text-gradient">A Tiempo</span>',
  heroSubtitle: 'Somos especialistas en tratamientos para TDAH y salud neurológica. Compra de forma segura y recibe donde estés.',
  benefits: [
    { icon: 'bolt', title: 'Entregas Express', desc: 'No interrumpas tu tratamiento.' },
    { icon: 'shield', title: 'Compra Segura', desc: 'Transacciones protegidas y confiables.' },
    { icon: 'medical_services', title: 'Garantía Médica', desc: 'Productos con los más altos estándares.' }
  ]
};
